import { useState, useEffect } from "react";
import { Form } from "antd";
import { elToast } from "../../functions/alertas";
import moment from "moment";
import { URL_BACKEND } from "../../api/url";
import { formatearFecha, formatearHora } from "../../functions/formatearHora";

const useConfiguracionesAplicacion = () => {

  const [disabled, setDisabled] = useState(true);

  const [form] = Form.useForm();

  const onFinish = (values) => {

    //formatear fechas y horas
    values.fecha_acceso_examen = formatearFecha(values.fecha_acceso_examen);

    values.hora_inicial_acceso = formatearHora(values.hora_inicial_acceso);
    values.hora_final_acceso = formatearHora(values.hora_final_acceso);

    values.fecha_aplicacion = formatearFecha(values.fecha_aplicacion);

    //validar si la hora inicial es antes que la hora final
    if (values.hora_inicial_acceso < values.hora_final_acceso) {

      // registrar o actualizar configuración
      let formData = new FormData();
      formData.append("funcion", "configurarAplicacionExamen");
      formData.append("valores", JSON.stringify(values));

      fetch(URL_BACKEND, {
        method: "POST",
        body: formData,
      })
      .then((res) => res.json())
      .then((r) => {

        // eslint-disable-next-line
        if (r.codigo == 1) {

          elToast(r.mensaje);

        // eslint-disable-next-line
        } else if (r.codigo == 0) {

          elToast(r.mensaje, "error");

        }

      })
      .catch(() => { console.log("error!"); });

    } else {

      elToast("La hora inicial debe ser antes que la hora final.", "info");

    }

  };


  const onFinishFailed = (error) => {

    elToast("Ocurrió un error al guardar los datos.", "error");

    console.log(error);

  };


  useEffect(() => {

    // traer datos de configuracion para colocarlos en los campos del menú
    let formData = new FormData();
    formData.append("funcion", "traerConfiguracionesAplicacion");

    fetch(URL_BACKEND, {
      method: "POST",
      body: formData
    })
    .then((res) => res.json())
    .then((d) => {

      if (d) {

        // colocar los datos en los campos respectivos: para las fechas y horas se necesita usar "moment"
        form.setFieldsValue({
          fecha_acceso_examen: moment(d["fecha_acceso_examen"]),
          hora_inicial_acceso: moment(d["hora_inicial_acceso"], "HH:mm:ss"),
          hora_final_acceso: moment(d["hora_final_acceso"], "HH:mm:ss"),
          fecha_aplicacion: moment(d["fecha_aplicacion"]),
          numero_aplicacion: d["numero_aplicacion"],
        });

      } else {

        //si d es "false" no se hace nada, los campos de configuraciones quedan vacíos

        elToast("No hay registro de configuraciones previas.", "info");

      }

      setDisabled(false);

    })
    .catch((e) => console.log(e));

    // eslint-disable-next-line
  }, [])




  return {
    form,
    onFinish,
    onFinishFailed,
    disabled
  }

}

export default useConfiguracionesAplicacion;